module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Angle-double-right-874ee53f05f0cb374d05aab91ca962e4.svg";